
// import "./style.scss"
import React from "react";
import { DeleteButton, DeleteButtonProps } from "atoms/Buttons/DeleteButton";
import { DownloadButton, DownloadButtonProps } from "atoms/Buttons/DownloadButton";
import MoveButton, { MoveButtonProps } from "atoms/Buttons/MoveButton";
import { CardsList, CardsListSelectAllProps } from "organisms/CardsList";
import ContactCard from "molecules/cards/ContactCard";
import { GetSelectedButton, GetSelectedButtonProps } from "atoms/Buttons/GetSelectedButton";

export interface ContactsCardsListProps {
    checkedMap: any;
    total: number;
    contacts: any;
    selectedContactsMap: any;
    searchInfinite: () => void,
    isSearchInfiniteLoading: boolean,
    onToggleSelectAll: () => void,
    onToggleChecked: (contactId: string) => void,
    onGetContact: any,
    filters: any,
    delete: DeleteButtonProps;
    move: MoveButtonProps;
    download: DownloadButtonProps;
    selectAll: CardsListSelectAllProps;
    revealSelected: GetSelectedButtonProps;
    contactsChecked: number;
}

export const ContactsCardsList = (props: ContactsCardsListProps) => {

    return (
        <div key={'producer_results'} className="cards" style={{ marginTop: "10px" }}>
            <CardsList
                rows={props.contacts ? props.contacts : null}
                getCard={k => {
                    return (
                        <ContactCard
                            key={k.employee_profile_url + props.checkedMap[k.employee_profile_url]}
                            anonymizedContact={k}
                            contact={props.selectedContactsMap[k.employee_profile_url]}
                            isChecked={props.checkedMap[k.employee_profile_url]}
                            toggleContactChecked={props.onToggleChecked}
                            onGetContact={props.onGetContact}
                        />
                    );
                }}
                getLoadingCard={() => (
                    <ContactCard
                        key={1}
                        anonymizedContact={null}
                        contact={null}
                        isChecked={false}
                        toggleContactChecked={() => {}}
                        onGetContact={null}
                    />
                )}
                searchInfinite={() => props.searchInfinite()}
                isInfiniteLoading={props.isSearchInfiniteLoading}
                buttons={[
                    <GetSelectedButton
                        title="Get Selected"
                        {...props.revealSelected}
                    />,
                    <DeleteButton
                        title="Delete Selected"
                        {...props.delete}
                    />,
                    <MoveButton
                        title="Move Selected"
                        {...props.move}
                    />,
                    <DownloadButton
                        title="Export Selected"
                        {...props.download}
                    />
                ]}
                selectAll={props.selectAll}
            />
        </div>
    );

}
